import {Component, OnInit} from '@angular/core';
import {animation} from '../../../shared/animations/animations';
import {ActivatedRoute, Router} from "@angular/router";
import {AuthTokenService} from '../../../shared/services/auth-token.service';
import {PreviousUrlService} from "../../../shared/services/previous-url.service";
import {SurveyService} from "../surveys.service";
import {PaidOrNotPaidModel, PaymentPDModel} from "../../../models/survey/survey.model";

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.less'],
  animations: [animation],
})
export class PaymentsComponent implements OnInit {

  dropdown = false;
  payFilter: any[] = [];
  paidDropdown = false;
  filter = false;
  payments: Array<any>;
  column = 'lastName';
  loader: boolean = false;
  isDesc = false;
  date = '11/12/2016';
  surveyId: number;
  surveyTitle: string;
  dropdownLabel: string;
  data = new PaidOrNotPaidModel();
  paid: number;
  notPaid: number;

  paymentPDModel: PaymentPDModel;
  filteredPaymentPDModel: any[] = [];

  constructor(private router: Router, private route: ActivatedRoute, private shareService: PreviousUrlService, private surveyService: SurveyService) {
  }

  ngOnInit() {
    this.surveyId = parseInt(this.route.snapshot.paramMap.get('id'));
    this.getData();
  }

  getData() {
    this.loader = true;
    this.surveyService.getPayment(this.surveyId, null)
    .subscribe((response) => {
        this.paymentPDModel = response;
        for (const x of this.paymentPDModel.listPeople) {
          x.check = false;
        }
        this.filteredPaymentPDModel = this.paymentPDModel.listPeople;
        this.loader = false;
      },
      (error) => {
        this.loader = false;
        console.log(error);
      });
    this.surveyTitle = this.route.snapshot.paramMap.get('title');
    this.shareService.setSurveyTitle(this.surveyTitle);
    this.payFilter = ['All', 'Paid', 'Not Paid'];
    this.dropdownLabel = 'Select';
  }

  openFilter() {
    this.filter = true;
  }


  selectAll(e) {
    for (const x of this.filteredPaymentPDModel) {
      x.check = e.target.checked;
    }
  }

  payAll() {
    this.data = new PaidOrNotPaidModel();
    this.data.listPeople = [];
    this.data.surveyId = this.surveyId;
    for (const x of this.filteredPaymentPDModel) {
      if (x.check) {
        this.data.listPeople.push(x.id);
        x.payed = true;
        this.data.paid = true;
      }
    }
    this.loader = true;
    this.surveyService.payPeople(this.data)
      .subscribe((response) => {
        // for (const x of this.filteredPaymentPDModel) {
        //   x.check = false;
        // }
          this.getData();
        },
        (error) => {
          console.log(error);
        })
  }

  dontPayAll() {
    this.data = new PaidOrNotPaidModel();
    this.data.listPeople = [];
    this.data.surveyId = this.surveyId;
    this.loader = true;
    for (const x of this.filteredPaymentPDModel) {
      if (x.check) {
        this.data.listPeople.push(x.id);
        x.payed = false;
        this.data.paid = false;
      }
    }
    this.surveyService.payPeople(this.data)
      .subscribe((response) => {
          // for (const x of this.filteredPaymentPDModel) {
          //   x.check = false;
          // }
          this.getData();
        },
        (error) => {
          console.log(error);
        })
  }

  peopleSelected(p, e) {
    p.check = e;
    // this.data = new PaidOrNotPaidModel();
    // this.data.listPeople = [];
    // const index = this.data.listPeople.indexOf(p);
    // if(p.check){
    //   this.data.listPeople.push(p.id);
    //   this.data.paid = false;
    // }
    // else{
    //   this.data.paid = true;
    //   this.data.listPeople.splice(index,1);
    // }
  }


  closeFilter() {
    this.filter = false;
  }

  changeFilter(e) {
    this.dropdownLabel = e;
    if (e == 'All') {
      this.filteredPaymentPDModel = this.paymentPDModel.listPeople.filter(x => x)
    }
    if (e == 'Paid') {
      this.filteredPaymentPDModel = this.paymentPDModel.listPeople.filter(x => x.payed == true);
    }
    if (e == 'Not Paid') {
      this.filteredPaymentPDModel = this.paymentPDModel.listPeople.filter(x => x.payed == false);
    }
  }

  sort(user) {
    this.isDesc = !this.isDesc;
    this.column = user;
    const direction = this.isDesc ? 1 : -1;

    this.filteredPaymentPDModel.sort(function (a, b) {
      if (a[user] < b[user]) {
        return -1 * direction;
      }
      else if (a[user] > b[user]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }

  sortPaidOrTotal(user) {
    this.isDesc = !this.isDesc;
    this.column = user;
    const direction = this.isDesc ? 1 : -1;

    this.paymentPDModel.listPaymentForEachCurrency.sort(function (a, b) {
      if (a[user] < b[user]) {
        return -1 * direction;
      }
      else if (a[user] > b[user]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }

  toggleDropdown() {
    this.dropdown = !this.dropdown;
  }

  togglePaidFilter() {
    this.paidDropdown = !this.paidDropdown;
  }


  onClickOutside(event: Object) {
    if (event && event['value'] === true) {
      this.dropdown = false;
    }
  }


  print(): void {
    let printContents, popupWin;
    printContents = document.querySelector('.print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Survey</title>
          <style>
          
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

  downloadAsCsv() {
    let headers = new Headers({
      'Content-Type': 'text/csv'
    });

    let data = '';
    for (let item of this.paymentPDModel.listPeople) {
      data += item.lastName + ',' + item.firstName + ',' + item.paypalEmail + ',' + item.cost + ',' + item.completionDate + ',' + item.payed + '\r\n';
    }
    data += '\r\n';


    this.downloadFile(data);
  }

  downloadFile(data) {
    let blob = new Blob(['\ufeff' + data], { type: 'attachment/csv' });
    let url = window.URL.createObjectURL(blob);

    if(navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, 'report.csv');
    } else {
        let a = document.createElement('a');
        a.href = url;
        a.download = 'report.csv';
        document.body.appendChild(a);
        a.click();        
        document.body.removeChild(a);
    }
    window.URL.revokeObjectURL(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/payments/payments.component.ts